module.exports = __webpack_public_path__ + "img/behaviour-1.e22dfc13.gif";